import { DateTime } from "luxon"

//Housing Styles and components
import myStyle from "../../../styles/housing/HousingNotes.module.css"

//PrimeReact
import { Tooltip } from "primereact/tooltip"
import { Editor } from "primereact/editor"
import { Dialog } from "primereact/dialog"

export default function HousingNoteDetail({
  showNote,
  onHideNote,
  note,
  users,
  participants,
}) {
  const formatNoteDate = () => {
    const date = DateTime.fromISO(note.date, { zone: "utc" }).toLocal()
    return `${date.toLocaleString()} ${date.toLocaleString(
      DateTime.TIME_SIMPLE
    )} ${date.toFormat("ZZZZ")}`
  }

  let userName = note.userId

  if (note.userId === "-6") {
    userName = "System"
  }

  if (userName !== "System") {
    const user = users?.find((user) => user.staff_id === note.userId)

    if (!!user) {
      userName = `${user.staff_name_first} ${user.staff_name_last}`
    }
  }

  let participantName = undefined

  if (!!note.participantId) {
    const participant = participants?.find(
      (participant) => participant.participant_id === note.participantId
    )

    participantName = participant?.name2 || "Unknown participant"
  }

  return (
    <Dialog
      header={"Note detail"}
      visible={showNote}
      onHide={() => {
        onHideNote()
      }}
      style={{ width: "500px", maxHeight: "1000px" }}
    >
      <div className={myStyle.noteGridContainer}>
        <Tooltip target=".pnote-ttip" />

        <div className={`${myStyle.noteGridHouseTitle}`}>House:</div>

        <div className={`${myStyle.noteGridHouse}`}>
          {note.houseName || "Not linked to a house"}
        </div>
        <div className={myStyle.noteGridParticipantTitle}>Participant: </div>
        <div className={myStyle.noteGridParticipant}>
          {!!note.participantId ? participantName : "None (Manager log)"}{" "}
        </div>
        <div className={`${myStyle.noteGridUserTitle}`}>Staff:</div>
        <div className={`${myStyle.noteGridUser}`}>{userName}</div>
        <div className={`${myStyle.noteGridDateTitle}`}>Date: </div>
        <div className={`${myStyle.noteGridDate}`}>{formatNoteDate()}</div>
        <div className={`${myStyle.noteGridNote}`}>
          <Editor
            value={note.note}
            readOnly
            headerTemplate={<></>}
            style={{ width: "100%" }}
          />
        </div>
      </div>
    </Dialog>
  )
}
